import * as React from 'react'
import { usePromiseManager } from '../../../app-core/lib/util/PromiseManager'
import { useAsyncEffect } from '../../../app-core/lib/util/react'
import { Base_commonDeps } from './Base.commonDeps'

type Component<Props> = React.ComponentClass<Props> | React.FunctionComponent<Props>

export function Base_Importer<Props>(importComponent: () => Promise<Component<Props>>): React.FunctionComponent<Props> {
    const deps = Base_commonDeps()

    return (props: Props) => {
        const componentPM = usePromiseManager<Component<Props>>(deps)

        useAsyncEffect(async () => {
            componentPM.trigger(importComponent)
        }, [])

        return componentPM.render((component) => React.createElement(component, props))
    }
}
